import type { TFunction } from 'i18next';

/**
 * What deleting a pillar does to the objectives that carry it, worded from its
 * `linkedObjectivesCount`, with a dedicated sentence for the zero case rather than "0 objectif":
 * the pillar is unlinked from its objectives, which stay.
 *
 * `linkedObjectivesCount` is `undefined` only while the dialog's `pillar` prop itself is still null.
 */
export const getPillarDeleteImpactMessage = (
    t: TFunction,
    linkedObjectivesCount: number | undefined,
): string =>
    linkedObjectivesCount
        ? t('pillars.deleteImpactCount', { count: linkedObjectivesCount })
        : t('pillars.deleteImpactNone');
